import { api } from '@/scripts/api';

export const AccountsService = {
    getClient(accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/accounts/client-by-account/${accountId}`;
            
            api.get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    getAgency(accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/accounts/agency-by-account/${accountId}`;
            
            api.get(service)
                .then(resolve)
                .catch(reject);
        });
    },
}
